const swup = new Swup({
    containers: ['.uk-navbar-nav' ,'#swup', '.uk-lightbox'],
    animateHistoryBrowsing: true,
    plugins: [
        new SwupScrollPlugin({
            animateScroll: false
        }),
        new SwupSlideTheme({
            reversed: true
        }),
        new SwupScriptsPlugin({
            head: true,
            body: false
        })
    ]
});

$("document").ready(function () {
    $(".burger").click(function () {
        $(".nav-menu-mobile").toggleClass("open");
        $(".menu-list").toggleClass("list-open");
    });

    $(".link").click(function () {
      $( "#burger-menu" ).removeClass( "open" ).addClass( "close" );
      $( "#burger-menu-list" ).removeClass( "list-open" ).addClass( "close" );
    });
});